/* SG3 · JS único de la landing shampoo-gorras-v3 (cargado con defer desde sg3-01-hero).
   Vanilla, sin librerías. Cada módulo es un IIFE independiente y tolerante a que
   su sección no esté presente en la página. */

/* Guard global: el script se referencia desde héroe, oferta y reviews-lista
   (secciones removibles de forma independiente); si dos lo cargan, solo se ejecuta una vez. */
if (window.__sg3Init) { /* ya inicializado */ } else {
window.__sg3Init = true;

/* 1 · Disparo del formulario Releasit COD desde cualquier CTA [data-sg3-cod].
   Listener delegado a nivel documento, registrado una sola vez.

   Cantidad SIN sorpresas (regla 9.2, auditoría iteración 1): la cantidad se
   resuelve EN EL CLICK, no con estado global al cargar:
   - botón con data-sg3-qty → esa cantidad; sin data-sg3-qty → 1.
   (Las cards de pack de la oferta son botones data-sg3-cod directos con su
   propia data-sg3-qty; ya no existe estado de "pack elegido".)
   Fallback (M9): si Releasit no carga, envía el form nativo oculto SIEMPRE con
   cantidad 1 (el precio de catálogo de 1 kit es la única promesa que el checkout
   nativo puede cumplir; nunca cobra de más). */
(function () {
  if (window.__sg3CodInit) return;
  window.__sg3CodInit = true;

  function resolveQty(btn) {
    var q = btn && btn.getAttribute('data-sg3-qty');
    return q ? (parseInt(q, 10) || 1) : 1;
  }

  function syncQty(qty) {
    window.__sg3PackQty = qty;
    var appWrap = document.querySelector('.sg3-offer__cta-app');
    if (appWrap) {
      var appQty = appWrap.querySelector('input[name="quantity"]');
      if (appQty) {
        appQty.value = qty;
        appQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function fireCod() {
    /* Busca el botón de Releasit DENTRO del contenedor oculto de la oferta. Como
       el contenedor solo tiene el app block de Releasit, cualquier botón/enlace
       ahí dentro ES el de Releasit — robusto a cómo lo nombre la app. */
    var wrap = document.querySelector('.sg3-offer__cta-app');
    var btn = null;
    if (wrap) {
      btn = wrap.querySelector('._rsi-buy-now-button')
        || wrap.querySelector('button')
        || wrap.querySelector('[role="button"]')
        || wrap.querySelector('a[href]');
    }
    if (!btn) {
      btn = document.querySelector('._rsi-buy-now-button-product')
        || document.querySelector('._rsi-buy-now-button')
        || document.getElementById('rsi_buy_now_button')
        || document.querySelector('[id^="rsi_buy_now"]');
    }
    if (btn) { btn.click(); return true; }
    return false;
  }

  function fireNativeFallback() {
    var form = document.querySelector('[data-sg3-native-form]');
    if (!form) return false;
    var qty = form.querySelector('input[name="quantity"]');
    if (qty) qty.value = 1;
    form.submit();
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-sg3-cod]');
    if (!t) return;
    e.preventDefault();
    syncQty(resolveQty(t));
    if (fireCod()) return;
    if (fireNativeFallback()) return;
    var offer = document.getElementById('sg3-oferta');
    if (offer) offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

/* 3 · Fecha de hoy en hora Colombia para los call-outs [data-sg3-today].
   El Liquid ya renderiza la fecha server-side; esto la reafirma en el cliente
   (Cloudflare cachea HTML, la fecha del servidor puede quedar vieja). */
(function () {
  var nodes = document.querySelectorAll('[data-sg3-today]');
  if (!nodes.length) return;
  var meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var d, m;
  try {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Bogota', day: '2-digit', month: '2-digit', year: 'numeric' }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    d = parseInt(o.day, 10);
    m = parseInt(o.month, 10) - 1;
  } catch (e) {
    var now = new Date();
    d = now.getDate();
    m = now.getMonth();
  }
  var txt = d + ' de ' + meses[m];
  for (var i = 0; i < nodes.length; i++) nodes[i].textContent = txt;
})();

/* 4 · Estimador de entrega [data-sg3-eta]: el Liquid renderiza el rango
   server-side (sin "—" placeholders, cero reflow); el JS solo lo reafirma en
   hora Colombia por si el HTML llegó cacheado. data-days-min / data-days-max. */
(function () {
  var box = document.querySelector('[data-sg3-eta]');
  if (!box) return;
  var min = parseInt(box.getAttribute('data-days-min'), 10) || 2;
  var max = parseInt(box.getAttribute('data-days-max'), 10) || 4;
  if (max < min) max = min;
  var meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  function fmt(offsetDays) {
    var base = new Date();
    try {
      var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Bogota', day: '2-digit', month: '2-digit', year: 'numeric' }).formatToParts(base);
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      base = new Date(parseInt(o.year, 10), parseInt(o.month, 10) - 1, parseInt(o.day, 10));
    } catch (e) { /* usa la fecha local */ }
    base.setDate(base.getDate() + offsetDays);
    return base.getDate() + ' de ' + meses[base.getMonth()];
  }
  var s = box.querySelector('[data-sg3-eta-start]');
  var e2 = box.querySelector('[data-sg3-eta-end]');
  if (s) s.textContent = fmt(min);
  if (e2) e2.textContent = fmt(max);
})();

/* 6 · Reviews [data-sg3-revl-list]: paginación + selector de orden. Todas las
   cards ya vienen en el HTML (server-side); esto solo muestra la página activa
   y reordena nodos en el cliente (cero requests). Sin JS se ven todas las
   reviews en orden de importación — degradación elegante.
   "Mejor calificadas" = orden curado del admin (campo orden del metaobjeto,
   expuesto como data-sg3-orden en cada card; Liquid no puede ordenarlo
   server-side porque sort no accede a field.value en metaobjetos).
   "Más recientes" = fecha descendente (data-sg3-fecha de cada card).
   Corre en idle: la lista está bajo el fold y sin JS ya se ve completa, así que
   ordenar/paginar puede esperar a que el main thread se desocupe (INP). */
(function () {
  var run = function () {
  var list = document.querySelector('[data-sg3-revl-list]');
  if (!list) return;
  var pager = document.querySelector('[data-sg3-revl-pager]');
  var cards = Array.prototype.slice.call(list.children);
  var size = parseInt(list.getAttribute('data-page-size'), 10) || 6;
  var pages = Math.ceil(cards.length / size);
  var hasPager = !!pager && pages > 1;
  var current = 1;

  function show(page) {
    current = page;
    var from = (page - 1) * size;
    var to = from + size;
    for (var i = 0; i < cards.length; i++) {
      cards[i].hidden = i < from || i >= to;
    }
    if (!hasPager) return;
    var prev = pager.querySelector('[data-prev]');
    var next = pager.querySelector('[data-next]');
    if (prev) prev.disabled = page === 1;
    if (next) next.disabled = page === pages;
  }

  function goTo(page) {
    show(page);
    var top = list.getBoundingClientRect().top;
    if (top < -40) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function mkBtn(label, attrs, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sg3-revl__page-btn' + (cls ? ' ' + cls : '');
    b.textContent = label;
    for (var k in attrs) b.setAttribute(k, attrs[k]);
    return b;
  }

  if (hasPager) {
    var prevBtn = mkBtn('\u2039 Anterior', { 'data-prev': '', 'aria-label': 'P\u00e1gina anterior' }, 'sg3-revl__page-btn--nav');
    prevBtn.addEventListener('click', function () { if (current > 1) goTo(current - 1); });
    pager.appendChild(prevBtn);
    var nextBtn = mkBtn('Siguiente \u203a', { 'data-next': '', 'aria-label': 'P\u00e1gina siguiente' }, 'sg3-revl__page-btn--nav');
    nextBtn.addEventListener('click', function () { if (current < pages) goTo(current + 1); });
    pager.appendChild(nextBtn);
  }

  /* Orden curado: se aplica al cargar (num\u00e9rico por data-sg3-orden; sin orden
     \u2192 al final; Array.sort es estable, los empates conservan el orden de
     importaci\u00f3n). */
  var curated = cards.slice();
  curated.sort(function (a, b) {
    var oa = parseInt(a.getAttribute('data-sg3-orden'), 10);
    var ob = parseInt(b.getAttribute('data-sg3-orden'), 10);
    if (isNaN(oa)) oa = 9999;
    if (isNaN(ob)) ob = 9999;
    return oa - ob;
  });

  var applySort = function (mode) {
    cards = curated.slice();
    if (mode === 'recientes') {
      cards.sort(function (a, b) {
        var fa = a.getAttribute('data-sg3-fecha') || '';
        var fb = b.getAttribute('data-sg3-fecha') || '';
        return fb < fa ? -1 : fb > fa ? 1 : 0;
      });
    }
    for (var i = 0; i < cards.length; i++) list.appendChild(cards[i]);
    show(1);
  };
  applySort('calificadas');

  /* Selector de orden: reordena los nodos y vuelve a la p\u00e1gina 1. */
  var sortBox = document.querySelector('[data-sg3-revl-sort]');
  if (sortBox) {
    var sortLabel = sortBox.querySelector('[data-sg3-sort-label]');
    var opts = sortBox.querySelectorAll('[data-sort]');

    Array.prototype.forEach.call(opts, function (opt) {
      opt.addEventListener('click', function () {
        Array.prototype.forEach.call(opts, function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        if (sortLabel) sortLabel.textContent = opt.textContent.trim();
        sortBox.removeAttribute('open');
        applySort(opt.getAttribute('data-sort'));
      });
    });

    document.addEventListener('click', function (e) {
      if (sortBox.hasAttribute('open') && !sortBox.contains(e.target)) sortBox.removeAttribute('open');
    });
  }
  };
  if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2000 });
  else setTimeout(run, 1);
})();

/* 7 · Sticky CTA (gorras v3 / v3.1 / v3.2): barra fija que aparece tras pasar el
   héroe y se oculta cuando la oferta (#sg3-oferta) está a la vista, para no
   competir con el CTA real. La visibilidad de la oferta la mantiene un
   IntersectionObserver (cero lecturas de layout por frame de scroll); el
   handler de scroll solo lee scrollY. Su botón es un [data-sg3-cod] normal. */
(function () {
  var bar = document.querySelector('[data-sg3-sticky]');
  if (!bar) return;
  var offer = document.getElementById('sg3-oferta');
  var showAfter = 420;
  var offerVisible = false;
  var ticking = false;
  function update() {
    ticking = false;
    var y = window.scrollY || document.documentElement.scrollTop;
    bar.classList.toggle('is-visible', y > showAfter && !offerVisible);
  }
  if (offer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      offerVisible = entries[entries.length - 1].isIntersecting;
      update();
    }).observe(offer);
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();

}
